/**
 * API 基址单点：主线程（协议页直链等）与 Worker 入口共用。
 * 纯常量 + 纯函数，两侧打包各自内联，不会把 Worker 代码拖进首屏。
 *
 * 路线设置（14.39，legacy §6.5）：用户可切「海外路线」——同一套代码换 API 域名。
 * 当前生效值的事实源是 Worker 全局库 kv（`worker/net/route.ts`），主线程镜像在
 * `GlobalState.netRoute`。**展示/直链一律读切片，不要直接读这里的常量**，
 * 否则切到海外路线后链接还指向国内域名。
 *
 * 国内（默认）路线 21ah-4 起 = **空串 = 同源**（人工指图「默认是请求当前域名下的
 * 接口」）：请求拼出来是 `/front/...` 相对路径，前端与 API 同域反代时不必配任何
 * 东西；Worker 里的相对 fetch 按 worker 自身 origin 解析，SW 也不碰（policy 只拦
 * 导航与 /assets|/icons|/splash）。非同源部署（dev/预发、前端挂 CDN）用构建期
 * `VITE_API_BASE` 覆盖——`.env.development` 里就写着 dev 域名，`pnpm e2e` 的构建
 * 也显式带上它（桩按绝对 origin 匹配）。
 */

/**
 * 国内（默认）路线。空串=同源（见文件头），构建期 `VITE_API_BASE` 可覆盖。
 * ⚠️ 展示用途要过 `apiBaseDisplay()`——空串直接显出来是一片空白。
 */
export const DEFAULT_API_BASE_URL = import.meta.env.VITE_API_BASE ?? '';

/** 海外路线（旧版 AppConstants.overseasApiBaseUrl 同值，不随 VITE_API_BASE 变） */
export const OVERSEAS_API_BASE_URL = 'https://im.kdpay.top';

/** 开关 → 基址（Worker 的 route 服务与主线程展示共用这一个映射） */
export function apiBaseUrlFor(overseas: boolean): string {
  return overseas ? OVERSEAS_API_BASE_URL : DEFAULT_API_BASE_URL;
}

/**
 * 基址 → 展示文案（路线设置页副标题等）：同源（空串）时显当前站点 origin，
 * 否则原样。调用方传 `location.origin`——纯函数不碰全局。
 */
export function apiBaseDisplay(baseUrl: string, origin: string): string {
  return baseUrl !== '' ? baseUrl : origin;
}
